import { render } from "./Standaloneform.vue?vue&type=template&id=1139ee4c&scoped=true"
import script from "./Standaloneform.vue?vue&type=script&lang=js"
export * from "./Standaloneform.vue?vue&type=script&lang=js"

import "./Standaloneform.vue?vue&type=style&index=0&id=1139ee4c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1309399801/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1139ee4c"]])

export default __exports__